import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
    selector: 'app-project-manager-list-modal',
    templateUrl: './project-manager-list-modal.component.html',
    styleUrls: ['./project-manager-list-modal.component.scss'],
})
export class ProjectManagerListModalComponent implements OnInit {
    @Input() projectsList: any[];
    @Input() currentInstance: string;
    @Input() type?: string;
    @Input() itemName?: string;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    pageEvent: PageEvent;
    selectedProject: any;
    searchInput: string = '';
    projectsListCopy: any[];
    totalProjects = 0;
    pageSize = 10;
    currentPage = 1;
    currentPageIndex = 0;
    Projects: any[] = [];

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.projectsListCopy = this.projectsList.slice();
        this.Projects = this.projectsList.slice();
        this.loadProjects();
    }

    searchResult(event): void {
        this.currentPage = 1; // Reset to the first page when searching
        this.currentPageIndex = 0; // Reset current page index

        if (this.searchInput.trim() !== '') {
            this.projectsListCopy = this.projectsListCopy.filter((item) => {
                return (
                    (item.namePrimary ?? '').toLowerCase().includes(this.searchInput.trim().toLowerCase()) ||
                    (item.name ?? '').toLowerCase().includes(this.searchInput.trim().toLowerCase())
                );
            });
        }

        if (event.key === 'Backspace') {
            this.projectsListCopy = this.Projects;
        }

        if (this.paginator) {
            this.paginator.firstPage(); // Reset the paginator to the first page
        }

        this.totalProjects = this.projectsListCopy.length; // Update the total projects
        this.loadProjects(); // Load filtered projects
        this.cd.detectChanges();
    }

    // Update the loadProjects function to use the filteredProjects array
    loadProjects(): void {
        this.projectsList = this.getProjects(this.currentPage, this.pageSize);
        this.totalProjects = this.projectsListCopy.length;
    }

    selectProject(p) {
        this.selectedProject = p;
        this.ngbActiveModal.close(this.selectedProject);
    }

    onPageChange(event: any): void {
        if (this.searchInput) {
        }
        this.currentPage = event.pageIndex + 1;
        this.pageSize = event.pageSize;
        this.loadProjects();
    }

    getProjects(page: number, pageSize: number): string[] {
        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return this.projectsListCopy.slice(startIndex, endIndex);
    }

    closeFunction() {
        this.ngbActiveModal.close();
    }
}
